import React, { useState, useEffect } from "react";
import { Modal, Button, message } from "antd";
import OTPInput from "otp-input-react";
import { APIRequest } from "../../Utils/APIManager";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { onLanguageChange } from "../../Redux/Actions/LanguageActions";
import { setProfile } from "../../Redux/Actions/UserActions";
import backgroundImage from "../../assets/background_logout.jpg";

const OtpVerificationModal = (props) => {
  const [visible, setVisible] = useState(false);
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const [isTamil, setIsTamil] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);

  // ✅ Listen for signup trigger event
  useEffect(() => {
    const handleOpen = (e) => {
      setEmail(e.detail.email);
      setIsTamil(e.detail.isTamil);
      setVisible(true);
      setTimer(30);
      setOtp("");
    };

    window.addEventListener("openOtpVerification", handleOpen);
    return () => window.removeEventListener("openOtpVerification", handleOpen);
  }, []);

  // ✅ Countdown timer
  useEffect(() => {
    if (visible && timer > 0) {
      const interval = setInterval(() => setTimer((t) => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [visible, timer]);

  // ✅ Handle OTP verification
  const handleVerify = async () => {
    message.destroy();
    if (!otp || otp.length < 6) {
      message.error(isTamil ? "OTP ஐ உள்ளிடவும்" : "Please enter the OTP");
      return;
    }
    setLoading(true);

    try {
      const res = await APIRequest.getPostService(
        "/users/verification",
        { verificationCode: otp },
        { "Accept-Language": isTamil ? "TAMIL" : "ENGLISH" }
      );

      if (res.status) {
        message.success(res.message);
        localStorage.setItem("agarathi_token", res.data.token);
        props.setProfile(res.data.userDetails);
        setVisible(false);
        props.history.replace("/"); // ✅ Redirect to home page
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handle resend OTP
  const resendOtp = async () => {
    try {
      const res = await APIRequest.getPostService(
        "/users/resend_verification_otp",
        { email },
        { "Accept-Language": isTamil ? "TAMIL" : "ENGLISH" }
      );

      if (res.status) {
        setOtp("");
        setTimer(30);
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error("Failed to resend OTP");
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      centered
      width={700}
      className="otp_fullpopup"
      bodyStyle={{
        padding: 0,
        borderRadius: "20px",
        overflow: "hidden",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "500px",
        position: "relative",
      }}
      destroyOnClose
    >
      <div
        className="flex flex-col items-center"
        style={{ marginTop: "15%", width: "50%", marginLeft: "45%" }}
      >
        <h2
          className="text-xl font-semibold mb-4"
          style={{ fontSize: "18px", marginRight: "2rem", textAlign: "center" }}
        >
          {isTamil ? "ஒரு முறை கடவுச்சொல் சரிபார்த்தல்" : "OTP Verification"}
        </h2>
        <OTPInput
          value={otp}
          onChange={setOtp}
          OTPLength={6}
          otpType="number"
          autoFocus
          inputClassName="otp-input"
        />
        <p className="text-sm mt-3" style={{ textAlign: "center" }}>
          {isTamil
            ? "ஒருமுறைக் கடவுச்சொல் கிடைக்கவில்லைவா?"
            : "Didn't receive the OTP?"}
        </p>
        <Button
          type="link"
          onClick={resendOtp}
          disabled={timer > 0}
          className="mt-2"
        >
          {isTamil
            ? `மீண்டும் அனுப்பவும் (${timer}s)`
            : `Resend OTP (${timer}s)`}
        </Button>
        <Button
          type="primary"
          onClick={handleVerify}
          loading={loading}
          disabled={otp.length < 6}
          className="mt-4 w-full"
          style={{
            backgroundColor: "#0FA6C9",
            borderRadius: "20px",
          }}
        >
          {isTamil ? "ஒரு முறை கடவுச்சொல் சரிபாருங்கள்" : "Verify OTP"}
        </Button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  LanguageReducer: state.LanguageReducer,
});

export default connect(mapStateToProps, {
  onLanguageChange,
  setProfile,
})(withRouter(OtpVerificationModal));